import { defineStore } from 'pinia'

export const usePersonalStore = defineStore('personal', {
  state: () => ({
    fullName: '',
    idCode: '',
    email: '',
    number: '',
    companyName: '',
    registrationNumber: '',
    representativeName: '',
    representativeIdCode: '',
    countryCode: '',
    confirmationViewAllowed: false,
    documentType: '',
    documentNumber: '',
  }),

  actions: {
    setFullName(value) {
      this.fullName = value
    },
    setIdCode(value) {
      this.idCode = value
    },
    setEmail(value) {
      this.email = value
    },
    setNumber(value) {
      this.number = value
    },
    setCompanyName(value) {
      this.companyName = value
    },
    setRegistrationNumber(value) {
      this.registrationNumber = value
    },
    setRepresentativeName(value) {
      this.representativeName = value
    },
    setRepresentativeIdCode(value) {
      this.representativeIdCode = value
    },
    setCountryCode(value) {
      this.countryCode = value
    },
    allowConfirmationView(value) {
      this.confirmationViewAllowed = value
    },
    setDocumentType(value) {
      this.documentType = value
    },
    setDocumentNumber(value) {
      this.documentNumber = value
    },
    resetPersonalState() {
      this.fullName = ''
      this.idCode = ''
      this.email = ''
      this.number = ''
      this.companyName = ''
      this.registrationNumber = ''
      this.representativeName = ''
      this.representativeIdCode = ''
      this.countryCode = ''
      this.confirmationViewAllowed = false
      this.documentType = ''
      this.documentNumber = ''
    },
  },
})
